<template>
  <div class="shade-box" v-if="redactData">
    <div class="shade" @click="getCancel"></div>

    <div class="shaItem">
      <div class="sha-item-head">
        <p class="head-title">编辑应用名称与LOGO</p>
        <p class="head-content">LOGO建议尺寸为1024*1024，方便打包切图</p>
      </div>
      <div class="shade-content">
        <div>
          <p class="app-name">应用主名称</p>
          <div class="el-inputs">
            <el-input
              class="item"
              v-model="content"
              :placeholder="content || '未命名应用'"
            ></el-input>
          </div>
        </div>

        <div>
          <p class="app-name">APP名称</p>
          <div class="el-inputs">
            <el-input
              class="item"
              v-model="appName"
              :placeholder="appName"
            ></el-input>
          </div>
        </div>

        <div style="padding-bottom: 20px">
          <div class="shade-img">
            <p class="logo-name">当前LOGO</p>

            <div
              class="LeftPng loginIMg"
              v-if="newData.icon"
              
            >
              <img style="width: 100%;height:100%" :src="newData.icon" alt="" />
            </div>

                <div
              class="LeftPng loginIMg"
              :style="'background:' + redactData.color"
              v-else
            >
              <img src="@/assets/images/niao.png" alt="" />
            </div>
          </div>
          <div class="shade-img">
            <p class="logo-name">上传新LOGO</p>

            <div class="avatar-uploader">
              <input
                id="fileInput"
                ref="refFile"
                type="file"
                @change="fileLoad"
              />
              <img class="ID1Base64" :src="ID1Base64" v-if="ID1Base64" alt="" />

              <img v-if="imageUrl" :src="imageUrl" class="avatar" />
              <i v-else class="avatar-uploader-icon"> 上传新logo </i>
            </div>
          </div>
        </div>
      </div>

      <div class="buttom-box">
        <div class="div1" @click="getCancel">取消</div>
        <div class="div2" @click="getEdit">确认更改</div>
      </div>
    </div>
  </div>
</template>


<script>
// 引入qrcode-decoder
import QrCode from "qrcode-decoder";
import request from "../utils/request";
export default {
  props: ["redactData", "newData"],
  data() {
    return {
      appName: "",
      content: "",
      imageUrl: "",
      ID1Base64: null,
      base1: null,
    };
  },
  mounted: function () {
      console.log(this.newData, "newData");
      console.log(this.redactData, "redactData");


    this.content = this.newData.name;
    this.appName = this.redactData.name;
  },

  methods: {
    // 保存
    getEdit: function () {
      let platform = {
        main: {
          name: this.content,
          // icon: this.base1,
        },

        [this.newData.platform]: {
          name: this.appName,
          icon: this.base1,
        },
      };


      request({
        url: "/api/app/edit",
        method: "POST",
        data: {
          uuid: this.redactData.uuid,
          platform: platform,
        },
      }).then((res) => {
        console.log(res);
         this.$emit("cancelPop", false);

      });
    },

    getCancel: function () {
      this.$emit("cancelPop", false);
    },
    fileLoad() {
      let selectedFile = this.$refs.refFile.files[0];
      let fileSize = 0;
      if (
        selectedFile.type != "image/jpeg" &&
        selectedFile.type != "image/png"
      ) {
        this.$message.error("请上传jpg或png格式的图片");
        return;
      }
      let suffix = selectedFile.type.split("/")[1];

      if (selectedFile) {
        fileSize = selectedFile.size / 1024;
        if (fileSize >= 1536) {
          alert("文件大小不能大于1536kb！");
          selectedFile.value = "";
          return;
        }
      }
      let reader = new FileReader();
      let name = selectedFile.name;
      let arr = name.split(".");
      reader.readAsDataURL(selectedFile);
      reader.onload = (e) => {
        let imgFile = e.target.result;
        let arr = imgFile.split(",");
        let faceBase64 = arr[1];
        let base = `data:image/${suffix};base64,`;

        this.ID1Base64 = base + faceBase64;
        this.base1 = faceBase64;
        console.log(this.ID1Base64);
        console.log(this.base1);
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.avatar-uploader {
  position: relative;
  width: 100%;
  height: 100%;
  border-radius: 12px;
  overflow: hidden;
  border: 1px dashed #d9d9d9;
  cursor: pointer;
}

.avatar-uploader .el-upload {
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  border: none;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #607f96;
  width: 120px;
  height: 120px;
  line-height: 178px;
  text-align: center;
  border-radius: 0;
  border: none;
  display: inline-block;
  font-size: 14px;
}
.avatar {
  width: 100%;
  height: 100%;
  display: block;
  border-radius: 12px;
}

.buttom-box {
  text-align: right;
  font-size: 14px;
  padding: 20px;
  div {
    display: inline-block;
    line-height: 14px;
    padding: 10px 27px;
    box-sizing: border-box;
  }

  .div1 {
    border: 1px solid #e2e8f0;
    opacity: 1;
    border-radius: 6px;
    color: #333333;
    margin-right: 5px;
  }

  .div2 {
    background: #1890ff;
    opacity: 1;
    border-radius: 6px;
    color: #fff;
  }
}

.shade-box {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 999;

  .shaItem {
    width: 460px;
    height: 519px;
    background: #ffffff;
    border-radius: 22px;
    position: absolute;
    box-sizing: border-box;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto auto;
    .sha-item-head {
      padding: 20px;
      width: 100%;
      height: 81px;
      box-sizing: border-box;
      border-bottom: 1px solid #f4f4f4;
      .head-title {
        color: #333333;
        font-size: 16px;
        line-height: 16px;
      }
      .head-content {
        color: #999999;
        font-size: 12px;
        line-height: 12px;
        margin-top: 6px;
      }
    }
  }
}

.shade {
  width: 100%;
  height: 100%;
  background: rgba($color: #333, $alpha: 0.2);
}

.shade-content {
  padding: 0 20px;
  border-bottom: 1px solid #f4f4f4;
  .app-name {
    line-height: 47px;
    color: #333333;
    font-size: 14px;
  }
  .logo-name {
    line-height: 50px;
  }
  .shade-img {
    display: inline-block;
    width: 120px;
    color: #333333;
    font-size: 14px;
    margin-right: 20px;
    vertical-align: top;
    position: relative;

    .loginIMg {
      border-radius: 12px;
    }
  }
}

.LeftPng {
  
  width: 120px;
  height: 120px;
  line-height: 120px;
  text-align: center;
  border-right: 16px;
  overflow: hidden;
  border-radius: 23px;
  position: relative;
}

.LeftPng > img {
  display: inline-block;
  width: 70%;

  vertical-align: middle;
}

.ID1Base64 {
  position: absolute;

  width: 100%;
  height: 100%;
  left: 0;
  z-index: 99;
  top: 0;
}

#fileInput {
  position: absolute;
  opacity: 0;
  width: 100%;
  height: 100%;
  left: 0;
  z-index: 999;
  cursor: pointer;
  border: none;
}

@media screen and (max-width: 600px) {
  .shaItem {
    width: 90vw !important;
  }
}

@media screen and (max-width: 350px) {
  .shaItem {
    width: auto !important;
  }
}

</style>